const DISTANCE_MARKS = [
	{value: 0, label: '25km'},
	{value: 1, label: '50km'},
	{value: 2, label: '75km'},
	{value: 3, label: '100km'},
];
const DISTANCE_VALUES = ['25', '50', '75', '100'];

const DEFAULT_DISTANCE = DISTANCE_VALUES[0];

export {DISTANCE_MARKS, DISTANCE_VALUES, DEFAULT_DISTANCE};
